import React, { useEffect } from "react";
import "./tournament-round-details.scss";

import { useDispatch, useSelector } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";
import {
  getTournament,
  setTournamentNotifications,
} from "../../../reducers/tournamentSlice";
import { faBolt, faChevronLeft, faPen } from "@fortawesome/free-solid-svg-icons";
import { GSSidePanelPage, GSItemList } from "golfstatus_react_components";
import {
  activateScorecards,
  clearRoundNotifications,
  getRound,
  getRoundScorecards,
  selectCurrentRound,
  selectCurrentRoundScorecards,
  selectLoading,
  selectRoundNotifications,
} from "../../../reducers/roundSlice";
import { RoundNavigationItems } from "../../../forms/TournamentRoundForms";
import NavigationListItem from "../../navigation-list-item";
import { useRoundHooks, getRoundName } from "../../../hooks/round/roundHooks";
import { usePreflighting } from "../../../hooks/flights/flightHooks";

const TournamentRoundDetails = (props) => {
  const dispatch = useDispatch();
  const match = useMatch("/:tournamentID/rounds/:roundID/*");
  const navigate = useNavigate();

  const tournamentID = match?.params?.tournamentID;
  const roundID = match?.params?.roundID;

  const currentRound = useSelector(selectCurrentRound);
  const roundNotifications = useSelector(selectRoundNotifications);
  const scorecards = useSelector(selectCurrentRoundScorecards);
  //the round's siblings decide whether it is shown as a sub round.
  const { allRounds } = useRoundHooks();
  const loading = useSelector(selectLoading);

  useEffect(() => {
    dispatch(getRound(roundID));
    dispatch(getRoundScorecards(roundID));
    return () => {
      dispatch(clearRoundNotifications())
    }
  }, [dispatch, roundID]);

  useEffect(() => {
    dispatch(getTournament(tournamentID));
  }, [dispatch, tournamentID]);

  const getRoundPageLayout = (page) => {
    return <NavigationListItem page={page} />;
  };

  const navigationItemSelected = (page) => {
    navigate(page.url);
  };

  let context = {};

  context.getLinks = () => {
    return (
      <GSItemList
        type="vertical"
        itemSelected={navigationItemSelected}
        items={RoundNavigationItems(currentRound, allRounds)}
        listItem={(page) => getRoundPageLayout(page)}
      ></GSItemList>
    );
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const deleteRound = () => {
    navigate("remove");
  };

  const revertRound = () => {
    navigate("deactivate");
  };

  const navigateToHoleAssignments = () => {
    navigate("hole-assignments");
  };

  const createScorecards = () => {
    dispatch(activateScorecards(roundID));
    navigate("scoring");
  };

  const getActions = () => {
    let actions = [];

    if (currentRound.state === "draft") {
      actions.unshift({ name: "Hole Assignments", buttonIcon: faBolt, action: navigateToHoleAssignments, type: "light-grey" });
      actions.push({ name: "Delete Round", action: deleteRound, type: "transparent red" },);
    }
    if (currentRound.state === "ready") {
      actions.unshift({ name: "Start Round", action: createScorecards, type: "green" });
      actions.push({ name: "Delete Round", action: deleteRound, type: "transparent red" },);
    }
    if (currentRound.state === "live") {
      if (scorecards?.length === 0) {
        actions.push({ name: "Generate Scorecards", action: createScorecards, type: "black no-wrap" });
      } else {
        actions.push({ name: "Edit Scorecards", buttonIcon: faPen, action: () => {navigate("scoring")}, type: "light-grey no-wrap" });
      }
      actions.push({ name: "deactivate round", action: revertRound, type: "light-grey" });
    }

    return actions;
  };

  const getNavigation = () => {
    return {
      title: `Round ${getRoundName(currentRound, allRounds)} Overview`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const timeoutAction = () => {
    dispatch(clearRoundNotifications());
    dispatch(setTournamentNotifications([]));
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "back",
        type: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };

  context.isCreate = () => {
    return roundID === "new";
  };

  const getContent = () => {
    return (
      <div className="content">
        {context.getLinks()}
      </div>
    );
  };
  
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };

  const notificationSettings = {notifications: roundNotifications, bannerActions: getBannerActions(), timeoutAction};
  const {getBanner} = usePreflighting({tournamentID, notificationSettings});

  return (
    <tournament-round-details>
      <GSSidePanelPage
        loading={loading?.length > 0}
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </tournament-round-details>
  );
};

export default TournamentRoundDetails;
